<script lang="ts" setup>
import './mGrid.scss';
import { ref, computed, onMounted, watch } from 'vue';
import { getSliderImages, getSliderVideos, videoUrl, getAvatar, videoPreview } from '../../../utils';
import { usePerformerStore } from '@/stores/performer';
import { useUserStore } from '@/stores/user';
import { useMediaStore } from '@/stores/media';
import { useAlertsStore } from '@/stores/alerts';
import { useRouter } from 'vue-router';
import { getStaticImages, isPaidMedia } from '@/utils';
import config from '../../../config';

const mediaStore = useMediaStore();
const { getCurrentMedia } = useMediaStore();

const props = defineProps<{ performer?: any; medias: any }>();
const emit = defineEmits(['toggleSlider']);

const vidPlayers = ref([]);
const showMoreMedia = ref(false);

onMounted(() => {
    showMoreMedia.value = false;
});

function getBackground(media: any){
    let url;
    if(media.type === 'video'){
        url = media.hasOwnProperty('namePreview') ? `${config.FullApiUrl}video/${props.performer.id}/medium/${media.namePreview}` : getStaticImages('vidplaceholder', 'jpg');
    } else {
        url = getStaticImages('placeholderprofile', 'jpg');
    }
    return url;
}

const showDuration = (media: any) => {
    return media.type === 'video' && (media.hasOwnProperty('duration') || media.duration > 0);
};

function tSlider(id: any){
    pauseVideos();
    return emit('toggleSlider', id);
}

function pauseVideos() {
    if (vidPlayers.value && Array.isArray(vidPlayers.value)) {
        for (const element of vidPlayers.value as Array<HTMLVideoElement>) {
            if (element) {
                element.pause();
            }
        }
    }
}
</script>

<template src="./mGrid.html"></template>